import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { ChevronDown } from 'lucide-react';

const Layout3Form = ({ data, onChange, errors }) => {
  const { video, brand, copy, cta } = data;
  const [campaigns, setCampaigns] = useState([]);

  const handleChange = (section, field, value) => {
    // let cleanedValue = (value || '').replace(/%/g, "");

    let cleanedValue = value;

    // Only clean string values
    if (typeof value === "string") {
      cleanedValue = (value || '').replace(/%/g, "");
    }


    if (field === 'url' || field === 'logoUrl' || field === 'imageUrl' || field === 'qrCodeUrl') {
      cleanedValue = value
    }
    onChange('layout3', section, field, cleanedValue);
  };

  const getCampaigns = async () => {
    try {
      const response = await api.get('campaign/list');
      if (response && response.data && response.data.data) {
        setCampaigns(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCampaigns();
  }, []);


  return (
    <div className="layout3-form">
      <div className="form-section">


        <div className="form-group">
          <label>Campaign Name</label>
          <div className="relative">
            <select
              value={data.camp_name}
              onChange={(e) => handleChange(null, "camp_name", e.target.value)}
              className={`appearance-none ${errors?.camp_name ? "has-error" : ""} `}
            >
              <option value="">Select Campaign</option>
              {campaigns.map((camp) => (
                <option key={camp.camp_id} value={camp.camp_name}>
                  {camp.camp_name}
                </option>
              ))}
            </select>
            <ChevronDown size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none" />
          </div>
          {errors?.camp_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.camp_name}
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Brand Name</label>

          <input
            type="text"
            value={data.brand_name || ''}
            onChange={(e) => handleChange(null, 'brand_name', e.target.value)}
            className={errors?.brand_name ? "has-error" : ""}
          />
          {errors?.brand_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.brand_name}
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Domain</label>
          <input
            type="text"
            value={data.domain || ''}
            onChange={(e) => handleChange(null, 'domain', e.target.value)}
            className={errors?.domain ? "has-error" : ""}
          />
          {errors?.domain && (
            <p className="text-red-500 text-sm mt-1">
              {errors.domain}
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Creative Name</label>
          <input
            type="text"
            value={data.creative_name || ''}
            onChange={(e) => handleChange(null, 'creative_name', e.target.value)}
            className={errors?.creative_name ? "has-error" : ""}
          />
          {errors?.creative_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.creative_name}
            </p>
          )}
        </div>
      </div>

      <div className="form-section">
        <h3>Canvas Settings</h3>
        <div className="form-group">
          <label>Background Type</label>
          <div className='relative'>
            <select
              value={data.canvas?.backgroundType || 'gradient'}
              onChange={(e) => handleChange('canvas', 'backgroundType', e.target.value)}
              className='appearance-none'
            >
              <option value="solid">Solid</option>
              <option value="gradient">Gradient</option>
            </select>
            <ChevronDown size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none" />
          </div>
        </div>

        {(data.canvas?.backgroundType || 'gradient') === 'solid' && (
          <div className="form-group">
            <label>Background Color</label>
            <div className="color-input-group">
              <input
                type="color"
                value={data.canvas?.backgroundColor || '#6b1f23'}
                onChange={(e) => handleChange('canvas', 'backgroundColor', e.target.value)}
              />
              <input
                type="text"
                value={data.canvas?.backgroundColor || '#6b1f23'}
                onChange={(e) => handleChange('canvas', 'backgroundColor', e.target.value)}
                placeholder="#6b1f23"
                className="color-text-input"
              />
            </div>
          </div>
        )}

        {(data.canvas?.backgroundType || 'gradient') === 'gradient' && (
          <>
            <div className="form-group">
              <label>Gradient Color 1</label>
              <div className="color-input-group">
                <input
                  type="color"
                  value={data.canvas?.gradientColor1 || '#6b1f23'}
                  onChange={(e) => handleChange('canvas', 'gradientColor1', e.target.value)}
                />
                <input
                  type="text"
                  value={data.canvas?.gradientColor1 || '#6b1f23'}
                  onChange={(e) => handleChange('canvas', 'gradientColor1', e.target.value)}
                  placeholder="#6b1f23"
                  className="color-text-input"
                />
              </div>
            </div>
            <div className="form-group">
              <label>Gradient Color 2</label>
              <div className="color-input-group">
                <input
                  type="color"
                  value={data.canvas?.gradientColor2 || '#a24a43'}
                  onChange={(e) => handleChange('canvas', 'gradientColor2', e.target.value)}
                />
                <input
                  type="text"
                  value={data.canvas?.gradientColor2 || '#a24a43'}
                  onChange={(e) => handleChange('canvas', 'gradientColor2', e.target.value)}
                  placeholder="#a24a43"
                  className="color-text-input"
                />
              </div>
            </div>
            <div className="form-group hidden">
              <label>Gradient Angle (deg)</label>
              <input
                type="number"
                min="0"
                max="360"
                value={data.canvas?.gradientAngle ?? 135}
                onChange={(e) => handleChange('canvas', 'gradientAngle', parseInt(e.target.value, 10) || 0)}
              />
            </div>
          </>
        )}

        <div className="form-group hidden">
          <label>Padding</label>
          <input
            type="text"
            value={data.canvas?.padding || '0px'}
            onChange={(e) => handleChange('canvas', 'padding', e.target.value)}
            placeholder="e.g. 48px 64px"
          />
        </div>
      </div>

      <div className="form-section">
        <h3>Video</h3>
        <div className="form-group">
          <label>Video or Instagram URL</label>
          <input
            type="text"
            value={video?.url || ''}
            onChange={(e) => handleChange('video', 'url', e.target.value)}
            placeholder="Enter video URL"
          />
          <span className='text-xs text-blue-500'>Aspect ratio: 9:16 (vertical)</span>
        </div>
      </div>

      <div className="form-section">
        <h3>Brand</h3>
        <div className="form-group">
          <label>Brand Name</label>
          <input
            type="text"
            value={brand?.name || ''}
            maxLength={25}
            onChange={(e) => handleChange('brand', 'name', e.target.value)}
            placeholder="Ralph Lauren"
          />
        </div>
        <div className="form-group">
          <label>Followers</label>
          <input
            type="text"
            value={brand?.followers || ''}
            maxLength={5}
            onChange={(e) => handleChange('brand', 'followers', e.target.value)}
            placeholder="331K Followers"
          />
        </div>
        <div className="form-group">
          <label>Verified</label>
          <div className='relative'>
            <select
              value={brand?.verified ? 'yes' : 'no'}
              onChange={(e) => handleChange('brand', 'verified', e.target.value === 'yes')}
              className='appearance-none'
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
            <ChevronDown size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none" />
          </div>
        </div>
        <div className="form-group">
          <label>Logo URL</label>
          <input
            type="text"
            value={brand?.logoUrl || ''}
            onChange={(e) => handleChange('brand', 'logoUrl', e.target.value)}
            placeholder="Enter logo image URL"
          />
          <p className="text-blue-600 text-xs">
            Image must be at least 150 × 150 pixels.
          </p>
        </div>
      </div>

      <div className="form-section">
        <h3>Copy</h3>
        <div className="form-group">
          <label>Title</label>
          <textarea
            rows="2"
            maxLength={35}
            value={copy?.title || ''}
            onChange={(e) => handleChange('copy', 'title', e.target.value)}
            placeholder="Polo Ralph Lauren: Men's Outerwear"
          />
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea
            rows="4"
            value={copy?.description || ''}
            maxLength={150}
            onChange={(e) => handleChange('copy', 'description', e.target.value)}
            placeholder="Description"
          />
        </div>
      </div>

      <div className="form-section">
        <h3>CTA</h3>
        <div className="form-group">
          <label>QR Code URL</label>
          <input
            type="text"
            value={brand?.qrCodeUrl || ''}
            onChange={(e) => handleChange('brand', 'qrCodeUrl', e.target.value)}
            placeholder="Enter QR code URL"
          />
        </div>
        <div className="form-group">
          <label>CTA Text</label>
          <input
            type="text"
            value={cta?.text || ''}
            onChange={(e) => handleChange('cta', 'text', e.target.value)}
            placeholder="Shop Now"
          />
        </div>
        <div className="form-group">
          <label>Website</label>
          <input
            type="text"
            value={cta?.website || ''}
            onChange={(e) => handleChange('cta', 'website', e.target.value)}
            placeholder="ralphlauren.com"
          />
        </div>
      </div>
    </div>
  );
};

export default Layout3Form;

